import { ShieldCheck, BadgeCheck, Leaf, Star, MapPin } from 'lucide-react';
import { TRUST_BADGES } from '../lib/site';

const ICONS = { ShieldCheck, BadgeCheck, Leaf, Star, MapPin };

export const TrustBadges = ({ variant = 'default' }) => {
    return (
        <div
            data-testid="trust-badges"
            className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-3 ${
                variant === 'dark' ? '' : ''
            }`}
        >
            {TRUST_BADGES.map((b) => {
                const Icon = ICONS[b.icon] || ShieldCheck;
                return (
                    <div
                        key={b.label}
                        className={`flex items-center gap-3 p-4 rounded-xl transition-colors ${
                            variant === 'dark'
                                ? 'bg-white/5 border border-white/10 text-white'
                                : 'bg-white border border-border'
                        }`}
                    >
                        <span className={`grid place-items-center w-9 h-9 rounded-full ${
                            variant === 'dark' ? 'bg-white/10 text-accent' : 'bg-muted text-primary'
                        }`}>
                            <Icon className="w-4 h-4" strokeWidth={1.6} />
                        </span>
                        <div className="leading-tight">
                            <div className={`font-outfit text-sm ${variant === 'dark' ? 'text-white' : 'text-foreground'}`}>
                                {b.label}
                            </div>
                            {b.sub && (
                                <div className={`text-[11px] ${variant === 'dark' ? 'text-white/60' : 'text-muted-foreground'}`}>
                                    {b.sub}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
